import { Ability, PureAbility } from '@casl/ability';
import { AbilityModule } from '@casl/angular';
import { GOOGLE_RECAPTCHA_KEY, GOOGLE_MAP_KEY } from '@env';

import { OverlayContainer } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { SnAuthModule } from '@lib/auth';
import { AuthPublicModule } from '@lib/auth/public';
import { SnCoreModule } from '@lib/core';
import { SnFormModule } from '@lib/form';
import { SnFormRecaptchaModule } from '@lib/form/recaptcha';
import { GoogleCoreModule } from '@lib/geo/google/core';
import { GooglePlacesModule } from '@lib/geo/google/places';
import { SnTitleModule } from '@lib/state/title';
import { SnBrandModule } from '@lib/ui/brand';
import { SnDialogModule } from '@lib/ui/dialog';
import { ExistingFullscreenOverlayContainer } from '@lib/ui/overlay';

@NgModule({
  imports: [
    // Others
    AbilityModule,
    // Libs
    SnCoreModule,
    SnTitleModule.forRoot(),
    SnFormModule.forRoot(),
    SnFormRecaptchaModule.forRoot(GOOGLE_RECAPTCHA_KEY),
    GoogleCoreModule.forRoot(GOOGLE_MAP_KEY),
    GooglePlacesModule.forRoot(),
    SnDialogModule.forRoot(),
    SnAuthModule.forRoot({
      signUpEnabled: true,
      isRegistry: true,
      redirectAuthorizedTo: '/locations',
    }),
    AuthPublicModule.forRoot(),
    SnBrandModule.forRoot('Fusus Registry', {
      icon: '/assets/logo/icon/fusus-registry-icon-accent.svg',
      iconInverse: '/assets/logo/icon/fusus-registry-icon-accent-inverse.svg',
      vertical: '/assets/logo/vertical/fusus-registry-vertical-accent.svg',
      verticalInverse: '/assets/logo/vertical/fusus-registry-vertical-accent-inverse.svg',
      horizontal: '/assets/logo/horizontal/fusus-registry-horizontal-accent.svg',
      horizontalInverse: '/assets/logo/horizontal/fusus-registry-horizontal-accent-inverse.svg',
    }),
  ],
  providers: [
    { provide: OverlayContainer, useClass: ExistingFullscreenOverlayContainer },
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability },
  ],
})
export class CoreModule {}
